import { mapActions } from "vuex";

export default {
    created() {

    },
    methods: {
        ...mapActions({
            saveAll: 'crudStore/saveAll',
        }),
        async actualizarFtn() {
            try {

            } catch {

            }
        },
        async saveForm(event) {
            try {
                const traslados_nuevos = []
                if (event.ftn !== undefined) {
                    switch (event.ftn) {
                        case 'registrarPLanillaFtn':
                            let retirados = this.tableSave.tableGetArchivo.btn0.filter(list => list.archivo_plano.id_list_novedad.toString() === '3' && list.check)
                            if (retirados.length > 0) {
                                let datos_afiliado = []
                                let info_afiliacion = []
                                let servicios_activos = []
                                let servicios_inits = []
                                let servicios_nuevos = []
                                for (let i = 0; i < retirados.length; i++) {
                                    if (this.dataGet[this.namePath].data[retirados[i].index].info_afiliacion !== null && this.dataGet[this.namePath].data[retirados[i].index].info_afiliacion.id_list_novedad === 3) {
                                        let datosAfiliado = this.dataGet[this.namePath].data[retirados[i].index].datos_afiliado
                                        datosAfiliado.id_list_estado = 2
                                        datos_afiliado.push(datosAfiliado)
                                        info_afiliacion.push(this.dataGet[this.namePath].data[retirados[i].index].info_afiliacion);
                                        for (let j = 0; j < this.dataGet[this.namePath].data[retirados[i].index].servicios_activos.length; j++) {
                                            servicios_activos.push(this.dataGet[this.namePath].data[retirados[i].index].servicios_activos[j])
                                            if (this.dataGet[this.namePath].data[retirados[i].index].servicios_activos[j].name !== 'Traslado') {
                                                let inits = this.deepCopy(this.dataGet[this.namePath].data[retirados[i].index].servicios_activos[j])
                                                inits.id = null
                                                inits.deleted_at = this.fecha().fecha.hoy
                                                inits.retiro = this.dataGet[this.namePath].data[retirados[i].index].archivo_plano.fecharetiro
                                                inits.nota_delete = 'retiro'
                                                servicios_inits.push(inits)
                                            } else if (this.dataGet[this.namePath].data[retirados[i].index].servicios_activos[j].nota_delete === null) {
                                                this.dataGet[this.namePath].data[retirados[i].index].servicios_activos[j].id = null
                                                this.dataGet[this.namePath].data[retirados[i].index].servicios_activos[j].iniciolabores = null
                                                traslados_nuevos.push(this.dataGet[this.namePath].data[retirados[i].index].servicios_activos[j])
                                            }
                                        }
                                        for (let j = 0; j < this.dataGet[this.namePath].data[retirados[i].index].servicios_nuevos.length; j++) {
                                            if (this.dataGet[this.namePath].data[retirados[i].index].servicios_nuevos[j].name !== 'Traslado') {
                                                servicios_nuevos.push(this.dataGet[this.namePath].data[retirados[i].index].servicios_nuevos[j])
                                            }
                                        }
                                    }
                                    if (this.dataGet[this.namePath].data[retirados[i].index].info_afiliacion !== null && this.dataGet[this.namePath].data[retirados[i].index].info_afiliacion.id_list_novedad !== 3) {
                                        for (let j = 0; j < this.dataGet[this.namePath].data[retirados[i].index].servicios_activos.length; j++) {
                                            let existe_archivo = _.findIndex(this.dataGet[this.namePath].data[retirados[i].index].servicios_archivo, { id: this.dataGet[this.namePath].data[retirados[i].index].servicios_activos[j].id, mes_periodo: this.dataGet[this.namePath].data[retirados[i].index].servicios_activos[j].mes_periodo, ano_periodo: this.dataGet[this.namePath].data[retirados[i].index].servicios_activos[j].ano_periodo })
                                            if (existe_archivo !== -1) {
                                                if (this.dataGet[this.namePath].data[retirados[i].index].servicios_activos[j].name !== 'Traslado') {

                                                    servicios_activos.push(this.dataGet[this.namePath].data[retirados[i].index].servicios_activos[j])
                                                    let inits = this.deepCopy(this.dataGet[this.namePath].data[retirados[i].index].servicios_activos[j])
                                                    inits.id = null
                                                    inits.deleted_at = this.fecha().fecha.hoy
                                                    inits.retiro = this.dataGet[this.namePath].data[retirados[i].index].archivo_plano.fecharetiro
                                                    inits.nota_delete = 'retiro'
                                                    servicios_inits.push(inits)
                                                }
                                            }
                                        }
                                    }
                                }

                                if (datos_afiliado.length === 0) {
                                    if (servicios_activos.length === 0) {
                                        await this.updateDataPost({
                                            data: {
                                                data: [],
                                                route: 'save_all',
                                                tablaAuditar: true,
                                                notaDelete: null,
                                                tablaPost: ['archivo_plano'],
                                                tablaDelete: []
                                            }
                                        })
                                    } else {
                                        await this.updateDataForm({ state: 'servicios_activos', data: servicios_activos })
                                        await this.updateDataForm({ state: 'servicios_inits', data: servicios_inits })
                                        await this.updateDataPost({
                                            data: {
                                                data: [],
                                                route: 'save_all',
                                                tablaAuditar: true,
                                                notaDelete: null,
                                                tablaPost: ['archivo_plano', 'servicios_activos', 'servicios_inits'],
                                                tablaDelete: ['servicios_activos']
                                            }
                                        })

                                    }
                                } else {
                                    await this.updateDataForm({ state: 'datos_afiliado', data: datos_afiliado })
                                    await this.updateDataForm({ state: 'info_afiliacion', data: info_afiliacion })
                                    await this.updateDataForm({ state: 'servicios_activos', data: servicios_activos })
                                    await this.updateDataForm({ state: 'servicios_nuevos', data: servicios_nuevos })
                                    await this.updateDataForm({ state: 'servicios_inits', data: servicios_inits })

                                    await this.updateDataPost({
                                        data: {
                                            data: [],
                                            route: 'save_all',
                                            tablaAuditar: true,
                                            notaDelete: null,
                                            tablaPost: ['archivo_plano', 'datos_afiliado', 'info_afiliacion', 'servicios_nuevos', 'servicios_activos', 'servicios_inits'],
                                            tablaDelete: ['info_afiliacion', 'servicios_activos', 'servicios_nuevos']
                                        }
                                    })

                                }
                            } else {
                                await this.updateDataPost({
                                    data: {
                                        data: [],
                                        route: 'save_all',
                                        tablaAuditar: true,
                                        notaDelete: null,
                                        tablaPost: ['archivo_plano'],
                                        tablaDelete: []
                                    }
                                })
                            }
                            break
                        case 'btn0':

                            let seleccionados = this.tableSave.tableGetArchivo.btn0
                            let ids = []
                            let ccfs = 0

                            for (let i = 0; i < seleccionados.length; i++) {
                                if (seleccionados[i].check) {
                                    ids.push(seleccionados[i].archivo_plano.id)
                                    if (seleccionados[i].archivo_plano.tipo == 1 && seleccionados[i].archivo_plano.codigoccf == null) {
                                        ccfs++
                                    }
                                }
                            }
                            if (ccfs === 0) {
                                window.open(this.url + '/api/pdf/archivoPlano?mes=' + this.filter.id_list_mes.id + '&ano=' + this.filter.id_list_ano.id + '&razon=' + this.filter.id_datos_razon.id + '&list=' + ids.toString() + '&planilla=&cor=false&prio='+this.filter.prioridad+'&token=' + this.token)

                            }

                            await this.updateGlobal({ state: 'openModal/modal', data: { value: true, title: 'Registrar No de planilla', modal: 'Planilla', mes: this.filter.id_list_mes.id, ano: this.filter.id_list_ano.id, razon: this.filter.id_datos_razon.id } })
                            return true

                            break
                        case 'anularRegistroFtn':
                            await this.updateDataForm({ state: 'info_ingresos/anulado', data: 1 })
                            await this.updateDataPost({
                                data: {
                                    data: [],
                                    route: 'save_all',
                                    tablaAuditar: true,
                                    notaDelete: this.dataForm[this.namePath].info_ingresos.nota_delete,
                                    tablaPost: ['info_ingresos'],
                                    tablaDelete: ['info_ingresos']
                                }
                            })
                            break;
                        case 'quitarPLanillaFtn':
                            await this.updateDataPost({
                                data: {
                                    data: event.data,
                                    route: 'removerPlanilla',
                                    tablaAuditar: true,
                                    notaDelete: null,
                                    tablaPost: [],
                                    tablaDelete: []
                                }
                            })
                            break
                    }
                }

                await this.save(event.save)

                if (event.ftn !== undefined) {
                    switch (event.ftn) {
                        case 'registrarPLanillaFtn':
                            if (traslados_nuevos.length > 0) {
                                await this.updateDataPost({
                                    data: {
                                        data: [{ servicios_nuevos: traslados_nuevos }],
                                        route: 'save_all',
                                        tablaAuditar: true,
                                        notaDelete: null,
                                        tablaPost: ['servicios_nuevos'],
                                        tablaDelete: []
                                    }
                                })
                                await this.save(event.save)
                            }
                            break
                    }
                }

                await this.getFiltrar()
                    // frotend await this.searchIdb({tabla:'servicios_nuevos',campo:'iniciolabores',value:'',principal:'info_afiliacion'})
                await this.resetDataIndex()
                await this.resetGlobal({ state: 'openModal' })
                await this.resetDataForm()
                await this.resetGlobal({ state: 'saveConfig/capa' })
            } catch (e) {
                console.log(e)
            }
        }
    },
}